import type { CheckoutProps } from "../CheckoutProps";

export const getCurrentUserName = (
  currentUser?: CheckoutProps["currentUser"],
) => {
  let name: string | undefined;

  if (currentUser?.name) {
    name = currentUser.name;
  } else if (currentUser?.first_name || currentUser?.last_name) {
    name = [currentUser.first_name, currentUser.last_name]
      .filter(value => !!value)
      .join(" ")
      .trim();
  }

  return name;
};
